/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Loading",
  height = 30,
  color = "rgb(50, 50, 50)",
  marginTop = 0,
  marginBottom = 0,
  backgroundColorBackground,
  backgroundColorForeground
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let dtTypographyLineheightM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-2mx3jB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-2-2mx3jB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Loading.Text"
  data-view-path={viewPath}
 style={{'--fs-3-2mx3jB': typeof dtTypographyFontsizeM === 'number' ? `${dtTypographyFontsizeM}px` : dtTypographyFontsizeM,'--fw-4-2mx3jB': dtTypographyFontweightRegular,'--lh-5-2mx3jB': dtTypographyLineheightM,'--h-6-2mx3jB': typeof height === 'number' ? `${height}px` : height,'--c-7-2mx3jB': color,'--mt-1-2mx3jB': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-2-2mx3jB': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-text ${styles.Text}`}
>
Loading camera
</span>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 backgroundColorBackground={backgroundColorBackground}
 backgroundColorForeground={backgroundColorForeground}
/>
</div>
{children}
</React.Fragment>)
}